'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sanitize_utility = require('../../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorComponent = function (_React$Component) {
  _inherits(ErrorComponent, _React$Component);

  function ErrorComponent(props) {
    _classCallCheck(this, ErrorComponent);

    var _this = _possibleConstructorReturn(this, (ErrorComponent.__proto__ || Object.getPrototypeOf(ErrorComponent)).call(this, props));

    _this.replaceRCLR = _this.replaceRCLR.bind(_this);
    return _this;
  }

  _createClass(ErrorComponent, [{
    key: 'replaceRCLR',
    value: function replaceRCLR(orginalUrl) {
      var updatedUrl = _string_utility2.default.replace(orginalUrl, /<COUNTRYCODE>/g, this.props.country.toLowerCase());
      updatedUrl = _string_utility2.default.replace(updatedUrl, /<LANGCODE>/g, this.props.language.toLowerCase());
      updatedUrl = _string_utility2.default.replace(updatedUrl, /<ROLECODE>/g, this.props.role.toLowerCase());
      return updatedUrl;
    }
  }, {
    key: 'render',
    value: function render() {
      var extendedClassName = this.props.className ? this.props.className : "";

      return _react2.default.createElement('div', { role: 'alert', 'data-testid': 'error-message',
        className: 'caption font-light text-center padding-all-25 overflow-auto ' + extendedClassName,
        dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.replaceRCLR(this.props.errorMessage)) } });
    }
  }]);

  return ErrorComponent;
}(_react2.default.Component);

exports.default = ErrorComponent;